
import {
  RANGE_TYPE_WEEK,
  RANGE_TYPE_MONTH,
  RANGE_TYPE_QUARTER,
  RANGE_TYPE_HALF_YEAR,
  RANGE_TYPE_YEAR,
  TYPE_MONTH,
  TYPE_YEAR,
  TYPE_WEEK,
  TYPE_QUARTER
} from "./enums";

import week from "./week";
import month from "./month";
import quarter from "./quarter";
import halfyear from "./halfyear";
import year from "./year";

export default {
  [RANGE_TYPE_WEEK]: week,
  [RANGE_TYPE_MONTH]: month,
  [RANGE_TYPE_QUARTER]: quarter,
  [RANGE_TYPE_HALF_YEAR]: halfyear,
  [RANGE_TYPE_YEAR]: year,
  [TYPE_MONTH]: month,
  [TYPE_YEAR]: year,
  [TYPE_WEEK]: week,
  [TYPE_QUARTER]: quarter
};
